import {Suspense, useEffect, useState} from "react";
import {ToastContainer} from "react-toastify";
import Header from "./Header.jsx";
import Footer from "./Footer.jsx";
import PaginationItems from "./component-assets/PaginationItems.jsx";
import PerPageModal from "./component-assets/PerPageModal.jsx";
import CampusDropDown from "./component-assets/CampusDropDown.jsx";
import {
    actionAppearance, bulkDeleteModal, checkAll, showModal, formFail, formSuccess, handleSubmitActions,
    paginateData, sortFunc, formCheck, range, convertSectoHHMM, calculateSendTime, convertHHMMtoSec, isBannerPresent,
    headerFilterFunc, searchFunc, swapModal
} from "../libs.jsx";
import BulkDeleteModal from "./component-assets/BulkDeleteModal.jsx";
import Button from "./component-assets/Button.jsx";
import {Pagination} from "react-bootstrap";
import {CSVLink} from "react-csv";
import ApiRequester from "./ApiRequester.jsx";
import TableBody from "./component-assets/TableBody.jsx";
import TableHeaders from "./component-assets/TableHeaders.jsx";
import {v4 as uuidv4} from "uuid";
import Navigation from "./Navigation.jsx";
import TableSkeleton from "./component-assets/skeletons/TableSkeleton.jsx";
import { getSession, setSession } from "../services/session";

const ScheduledReports = (props) => {
    let dData, bData, headerData, csvHeaders, areaTypeHeaders, deviceHeaders, residentHeaders, eventTypeHeaders, userHeaders,
        reasonHeaders, areaGroupHeaders, residentGroupHeaders, areaHeaders, userGroupHeaders, deviceCatHeaders;

    dData = getSession();


    headerData = [
        {label: "Report Description", key: "description", align: "left", filtered: true},
        {label: "Report Type", key: "report_type_name", align: "center", type: "capitalize", filtered: true},
        // {label: "Status", key: "enabled", align: "center", type: "bool", t: "Active", f: "Off"},
        {label: "Frequency", key: "frequency_name", align: "center", filtered: true},
        {label: "Send Time", key: "send_report_time", align: "center", type: "timeofday", filtered: true},
        {label: "Report Duration", key: "report_interval_name", align: "center", filtered: true},
        {label: "Last Sent", key: "last_sent", align: "center", type: "datetime-utc"},
        {label: "Next Send Time", key: "next_send_time", align: "center", type: "datetime-utc"},
        {label: "Receivers", key: "report_receiver", align: "center"}
    ];
    csvHeaders = [
        {label: "Report", key: "description"},
        {label: "Report", key: "report_type_name"},
        {label: "Active", key: "enabled"},
        {label: "Frequency", key: "frequency_name"},
        {label: "Send Time", key: "send_report_time"},
        {label: "Report Interval", key: "report_interval_name"},
        {label: "Report Filters", key: "report_filter_terms"},
        {label: "Last Sent", key: "last_sent"},
        {label: "Next Scheduled Time", key: "next_send_time"},
        {label: "Created On", key: "create_time"}
    ];

    areaHeaders = [
        {label: "Area Name", key: "area_name", align: "left",
            link: {enabled: true, type: "standard", linkto: "/profiles/area", linkkey: "area_id",
                inmodal: true, modalKey: "cancelFilterBtn2"}},
    ];
    areaGroupHeaders = [
        {label: "Group Name", key: "area_group_name", align: "left"},
        {label: "Description", key: "area_group_description", align: "left"}
    ];
    areaTypeHeaders = [
        {label: "Area Type", key: "area_type_name", align: "left"},
        {label: "Description", key: "area_type_description", align: "left"},
    ];
    deviceCatHeaders = [
        {label: "Category", key: "device_category_short_name", align: "left"},
    ];
    deviceHeaders = [
        {label: "Name", key: "device_name", align: "left"},
        {label: "Serial Number", key: "manufacture_uuid", align: "left"},
    ];
    residentHeaders = [
        {label: "First Name", key: "resident_first_name", align: "left",
            link: {enabled: true, type: "standard", linkto: "/profiles/resident", linkkey: "resident_id",
                inmodal: true, modalKey: "cancelFilterBtn2"}},
        {label: "Last Name", key: "resident_last_name", align: "left",
            link: {enabled: true, type: "standard", linkto: "/profiles/resident", linkkey: "resident_id",
                inmodal: true, modalKey: "cancelFilterBtn2"}},
        {label: "Nickname", key: "resident_nickname", align: "left"},
        {label: "Status", key: "is_active", align: "center", type: "bool", f: "Moved Out", t: "Active"}
    ];
    residentGroupHeaders = [
        {label: "Group Name", key: "resident_group_name", align: "left"},
        {label: "Description", key: "resident_description", align: "left"}
    ];
    userHeaders = [
        {label: "Username", key: "username", align: "left"},
        {label: "Display", key: "display_name", align: "left"},
        {label: "Role", key: "user_role", align: "left"}
    ];
    userGroupHeaders = [
        {label: "Group Name", key: "group_name", align: "left"}
    ];
    eventTypeHeaders = [
        {label: "Event Type", key: "event_type_name", align: "left"},
    ];
    reasonHeaders = [
        {label: "Reason", key: "reason_code_description", align: "left"},
    ];

    const [dataOrigin, setDataOrigin] = useState([]);
    const [activeData, setActiveData] = useState([]);
    const [tableRows, setTableRows] = useState([]);
    const [editable, setEditable] = useState(dData?.access?.Community?.Devices?.Write);
    const [count, setCount] = useState(0);
    const [campusId, setCampusId] = useState(dData.acnt);
    const [storePage, setStorePage] = useState(1);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(dData.perPage);
    const [tmpPerPage, setTmpPerPage] = useState(dData.perPage);
    const [dContent, setDContent] = useState([]);
    const [reportIdList, setReportIdList] = useState([]);
    const [headerFilters, setHeaderFilters] = useState([]);
    const [originLoaded, setOriginLoaded] = useState(false);
    const [freqLoaded, setFreqLoaded] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [skeleton, setSkeleton] = useState(<TableSkeleton />)
    // Edit scheduled report variables
    const [storedIndex, setStoredIndex] = useState(0);
    const [newEmails, setNewEmails] = useState([]);
    const [curEmails, setCurEmails] = useState([]);
    const [freqOptions, setFreqOptions] = useState([]);
    const [freqData, setFreqData] = useState([]);
    const [editFilterAreas, setEditFilterAreas] = useState("");
    const [editFilterAreaGroups, setEditFilterAreaGroups] = useState("");
    const [editFilterAreaTypes, setEditFilterAreaTypes] = useState("");
    const [editFilterDevCat, setEditFilterDevCat] = useState("");
    const [editFilterDevice, setEditFilterDevice] = useState("");
    const [editFilterEventType, setEditFilterEventType] = useState("");
    const [editFilterReason, setEditFilterReason] = useState("");
    const [editFilterRes, setEditFilterRes] = useState("");
    const [editFilterResGroup, setEditFilterResGroup] = useState("");
    const [editFilterUser, setEditFilterUser] = useState("");
    const [editFilterUserGroup, setEditFilterUserGroup] = useState("");
    const [editFilterResponse, setEditFilterResponse] = useState("  ");
    // Other Table Control Variables
    const [search, setSearch] = useState("");
    const [sorter, setSorter] = useState({
        sortColumn: "description",
        sortOrder: "asc"
    });
    const [ppRules, setPRules] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });
    const [csvLink, setLink] = useState({
        filename: "devices.csv",
        headers: [],
        data: []
    });
    const [csvButton, setCSVButton] = useState(
        <CSVLink {...csvLink} uFEFF={false}>
            <Button text={"Export"} icon={true} iconClass={"fe fe-download me-2"} class={"btn btn-primary ms-2 px-4 mt-1"} />
        </CSVLink>);
    const [tabItem, setTabItem] = useState("area");
    const [tabCat, setTabCat] = useState("areas");
    // Area Filter Table Variables
    const [areaOriginData, setAreaOriginData] = useState([]);
    const [areaTableRows, setAreaTableRows] = useState([]);
    const [areaDataCnt, setAreaDataCnt] = useState(0);
    const [areaIdList, setAreaIdList] = useState([]);
    const [areaSearch, setAreaSearch] = useState("");
    const [areaSorter, setAreaSorter] = useState({
        sortColumn: "area_name",
        sortOrder: "asc"
    });
    // Area Group Filter Table Variables
    const [areaGroupOriginData, setAreaGroupOriginData] = useState([]);
    const [areaGroupTableRows, setAreaGroupTableRows] = useState([]);
    const [areaGroupDataCnt, setAreaGroupDataCnt] = useState(0);
    const [areaGroupIdList, setAreaGroupIdList] = useState([]);
    const [areaGroupSearch, setAreaGroupSearch] = useState("");
    const [areaGroupSorter, setAreaGroupSorter] = useState({
        sortColumn: "area_group_name",
        sortOrder: "asc"
    });
    // Area Type Filter Table Variables
    const [areaTypeOriginData, setAreaTypeOriginData] = useState([]);
    const [areaTypeTableRows, setAreaTypeTableRows] = useState([]);
    const [areaTypeDataCnt, setAreaTypeDataCnt] = useState(0);
    const [areaTypeIdList, setAreaTypeIdList] = useState([]);
    const [areaTypeSearch, setAreaTypeSearch] = useState("");
    const [areaTypeSorter, setAreaTypeSorter] = useState({
        sortColumn: "area_type_name",
        sortOrder: "asc"
    });
    // Device Category Filter Table Variables
    const [devCatOriginData, setDevCatOriginData] = useState([]);
    const [devCatTableRows, setDevCatTableRows] = useState([]);
    const [devCatDataCnt, setDevCatDataCnt] = useState(0);
    const [devCatIdList, setDevCatIdList] = useState([]);
    const [devCatSearch, setDevCatSearch] = useState("");
    const [devCatSorter, setDevCatSorter] = useState({
        sortColumn: "device_category_short_name",
        sortOrder: "asc"
    });
    // Device Filter Table Variables
    const [devOriginData, setDevOriginData] = useState([]);
    const [devTableRows, setDevTableRows] = useState([]);
    const [devDataCnt, setDevDataCnt] = useState(0);
    const [devIdList, setDevIdList] = useState([]);
    const [devSearch, setDevSearch] = useState("");
    const [devSorter, setDevSorter] = useState({
        sortColumn: "device_name",
        sortOrder: "asc"
    });
    // Resident Filter Table Variables
    const [resOriginData, setResOriginData] = useState([]);
    const [resTableRows, setResTableRows] = useState([]);
    const [resDataCnt, setResDataCnt] = useState(0);
    const [resIdList, setResIdList] = useState([]);
    const [resSearch, setResSearch] = useState("");
    const [resSorter, setResSorter] = useState({
        sortColumn: "resident_first_name",
        sortOrder: "asc"
    });
    // Resident Group Filter Table Variables
    const [residentGroupOriginData, setResidentGroupOriginData] = useState([]);
    const [residentGroupTableRows, setResidentGroupTableRows] = useState([]);
    const [residentGroupDataCnt, setResidentGroupDataCnt] = useState(0);
    const [residentGroupIdList, setResidentGroupIdList] = useState([]);
    const [residentGroupSearch, setResidentGroupSearch] = useState("");
    const [residentGroupSorter, setResidentGroupSorter] = useState({
        sortColumn: "resident_group_name",
        sortOrder: "asc"
    });
    // Event Type Filter Table Variables
    const [eventTypeOriginData, setEventTypeOriginData] = useState([]);
    const [eventTypeTableRows, setEventTypeTableRows] = useState([]);
    const [eventTypeDataCnt, setEventTypeDataCnt] = useState(0);
    const [eventTypeIdList, setEventTypeIdList] = useState([]);
    const [eventTypeSearch, setEventTypeSearch] = useState("");
    const [eventTypeSorter, setEventTypeSorter] = useState({
        sortColumn: "event_type_name",
        sortOrder: "asc"
    });
    // User Filter Table Variables
    const [userOriginData, setUserOriginData] = useState([]);
    const [userTableRows, setUserTableRows] = useState([]);
    const [userDataCnt, setUserDataCnt] = useState(0);
    const [userIdList, setUserIdList] = useState([]);
    const [userSearch, setUserSearch] = useState("");
    const [userSorter, setUserSorter] = useState({
        sortColumn: "username",
        sortOrder: "asc"
    });
    // User Group Filter Table Variables
    const [userGroupOriginData, setUserGroupOriginData] = useState([]);
    const [userGroupTableRows, setUserGroupTableRows] = useState([]);
    const [userGroupDataCnt, setUserGroupDataCnt] = useState(0);
    const [userGroupIdList, setUserGroupIdList] = useState([]);
    const [userGroupSearch, setUserGroupSearch] = useState("");
    const [userGroupSorter, setUserGroupSorter] = useState({
        sortColumn: "group_name",
        sortOrder: "asc"
    });
    // Reason Filter Table Variables
    const [reasonOriginData, setReasonOriginData] = useState([]);
    const [reasonTableRows, setReasonTableRows] = useState([]);
    const [reasonDataCnt, setReasonDataCnt] = useState(0);
    const [reasonIdList, setReasonIdList] = useState([]);
    const [reasonSearch, setReasonSearch] = useState("");
    const [reasonSorter, setReasonSorter] = useState({
        sortColumn: "reason_code_description",
        sortOrder: "asc"
    });
    const [responseFilterList, setResponseFilterList] = useState([false, "lt", 60]);

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
             setCount(count => count - 1);
        }, 1000);
        if (count <= 0){
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt,
                                procedure: "getreportschedules", reqType: "stored"}).then(data => {
                setDataOrigin(data);
                setOriginLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, Tbl: "att_window_frequency",
                                procedure: "fetchall", reqType: "direct"}).then(data => {
                setFreqData(data);
                setFreqLoaded(true);
            });
            ApiRequester({reqEndpoint: "get-mysql-report", rep_type: "getportalfilters",
                                campus_id: campusId, device_category_filter: "1", area_type_filter: "1",
                                user_filter: "1", resident_group_filter: "1", area_filter: "0", area_group_filter: "1",
                                user_group_filter: "1", resident_filter: "1"}).then(data => {
                setDevCatOriginData(() => data?.device_categories?.length > 0 ? data.device_categories : []);
                setAreaTypeOriginData(() => data?.area_types?.length > 0 ? data.area_types : []);
                setResOriginData(() => data?.residents?.length > 0 ? data.residents : []);
                setUserOriginData(() => data?.users?.length > 0 ? data.users : []);
                setAreaOriginData(() => data?.areas?.length > 0 ? data.areas : []);
                setResidentGroupOriginData(() => data?.resident_groups?.length > 0 ? data.resident_groups : []);
                setUserGroupOriginData(() => data?.user_groups?.length > 0 ? data.user_groups : []);
                setAreaGroupOriginData(() => data?.area_groups?.length > 0 ? data.area_groups : []);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, Tbl: "core_reason_codes",
                                procedure: "fetchbyparameter", reqType: "direct"}).then(data => {
                data.push({cloud_reason_code_id: 0, reason_code_id: 0, reason_code_description: "No Reason", pal_reason_code_id: 0})
                setReasonOriginData(data);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, Tbl: "att_event_types",
                                procedure: "fetchall", reqType: "direct"}).then(data => {
                setEventTypeOriginData(data);
            });
            setCount(count => 600);
        }
        return () => clearInterval(interval);
    }, [count]);

    useEffect(() => {
        let pRules = paginateData(activeData, page, perPage);
        setPRules(pRules);
        if (activeData.length > 0) {
            activeData.sort((a, b) => sortFunc(a, b, sorter.sortColumn, sorter.sortOrder));
        }
        setTableRows(<TableBody start={pRules.start} end={pRules.end} tableData={activeData} checkbox={true}
                                writeAccess={editable} unk={"a-"} modal={freqLoaded}
                                actionAppearance={() => actionAppearance(pRules.start, pRules.end, ["deleteBtn"])}
                                tableHeaders={headerData} editModal={editModal} parentComponent={"Pendants"} dData={dData}
                                actionIcon={true} iconAction={(rowId) => sendReport(rowId)} checkboxlist={reportIdList}
                                setCheckboxId={(value) => {setReportIdList(value)}} checkidkey={"report_id"}
                                tzOffset={parseInt(dData?.campusData[campusId]?.tz_offset ? dData?.campusData[campusId]?.tz_offset : 0)} />);
    }, [activeData, sorter, page, perPage, dataOrigin, reportIdList, pageLoaded, freqLoaded]);

    useEffect(() => {
        setLink(prevState => {
            return {...prevState,
                headers: csvHeaders,
                data: dataOrigin}
        });
    }, [dataOrigin])

    useEffect(() => {
        setCSVButton(
            <CSVLink {...csvLink} uFEFF={false}>
                <Button text={"Export"} icon={true} iconClass={"fe fe-download me-2"} class={"btn btn-primary ms-2 px-4 mt-1"}/>
            </CSVLink>
        )
    }, [csvLink])

    useEffect(() => {
        if (![originLoaded].includes(false)){
            setPageLoaded(true);
        }
    }, [originLoaded]);

    useEffect(() => {
        // Performs realtime search of data as location types.
        let tmpData, pRules, searchKeys;

        let filteredData = headerFilterFunc(dataOrigin, headerFilters, headerData);

        searchKeys = ["report_type_name", "report_filter_terms", "frequency_name", "send_report_time"];
        tmpData = searchFunc(search, filteredData, searchKeys);

        pRules = paginateData(tmpData, page, perPage);
        if (search && page > pRules.pageMax){
            setPage(pRules.pageMax);
        }else if (!search){
            setPage(storePage);
        }
        setPRules(pRules);
        setActiveData(tmpData);
    }, [search, dataOrigin, headerFilters]);

    useEffect(() => {
        let tmp = [];
        for (let i=0; i < freqData?.length; i++){
            tmp.push(
                <option key={`freq-option-${i}`} value={freqData[i]?.window_frequency_id}>{freqData[i]?.frequency_name}</option>
            );
        }
        setFreqOptions(() => tmp)
    }, [freqData]);

    useEffect(() => {
        formCheck("editForm", "editSubmit");
    }, [newEmails])

    useEffect(() => {
        let tmpData, searchKeys;

        searchKeys = ["area_name"];
        tmpData = searchFunc(areaSearch, areaOriginData, searchKeys);

        setAreaDataCnt(tmpData.length);
        tmpData.sort((a, b) => sortFunc(a, b, areaSorter.sortColumn, areaSorter.sortOrder));
        setAreaTableRows(<TableBody start={0} end={tmpData.length} tableData={tmpData} checkbox={true} writeAccess={true}
                                    actionAppearance={() => {}} tableHeaders={areaHeaders} checkboxId={"uCheckArea"}
                                    parentComponent={"EventReports"} dData={dData} checkboxlist={areaIdList}
                                    modal={false} editModal={() => {}} unk={"area-x-"}
                                    setCheckboxId={(value) => {setAreaIdList(value)}} checkidkey={"area_id"} />);
    }, [areaOriginData, areaSorter, areaIdList, areaSearch]);

    useEffect(() => {
        let tmpData, searchKeys;

        searchKeys = ["area_group_name", "area_group_description"];
        tmpData = searchFunc(areaGroupSearch, areaGroupOriginData, searchKeys);

        setAreaGroupDataCnt(tmpData.length);
        tmpData.sort((a, b) => sortFunc(a, b, areaGroupSorter.sortColumn, areaGroupSorter.sortOrder));
        setAreaGroupTableRows(<TableBody start={0} end={tmpData.length} tableData={tmpData} checkbox={true} writeAccess={true}
                                        actionAppearance={() => {}} tableHeaders={areaGroupHeaders} checkboxId={"uCheckAreaGroup"}
                                        parentComponent={"EventReports"} dData={dData} checkboxlist={areaGroupIdList}
                                        modal={false} editModal={() => {}} unk={"area-group-x-"}
                                        setCheckboxId={(value) => {setAreaGroupIdList(value)}} checkidkey={"area_group_id"} />);
    }, [areaGroupOriginData, areaGroupSorter, areaGroupIdList, areaGroupSearch]);

    useEffect(() => {
        let tmpData, searchKeys;

        searchKeys = ["area_type_name", "area_type_description"];
        tmpData = searchFunc(areaTypeSearch, areaTypeOriginData, searchKeys);

        setAreaTypeDataCnt(tmpData.length);
        tmpData.sort((a, b) => sortFunc(a, b, areaTypeSorter.sortColumn, areaTypeSorter.sortOrder));
        setAreaTypeTableRows(<TableBody start={0} end={tmpData.length} tableData={tmpData} checkbox={true} writeAccess={true}
                                        actionAppearance={() => {}} tableHeaders={areaTypeHeaders} checkboxId={"uCheckAreaType"}
                                        parentComponent={"EventReports"} dData={dData} checkboxlist={areaTypeIdList}
                                        modal={false} editModal={() => {}} unk={"area-type-x-"}
                                        setCheckboxId={(value) => {setAreaTypeIdList(value)}} checkidkey={"area_type_id"} />);
    }, [areaTypeOriginData, areaTypeSorter, areaTypeIdList, areaTypeSearch]);

    useEffect(() => {
        let tmpData, searchKeys;

        searchKeys = ["device_name"];
        tmpData = searchFunc(devSearch, devOriginData, searchKeys);

        setDevDataCnt(tmpData.length);
        tmpData.sort((a, b) => sortFunc(a, b, devSorter.sortColumn, devSorter.sortOrder));
        setDevTableRows(<TableBody start={0} end={tmpData.length} tableData={tmpData} checkbox={true} writeAccess={true}
                                   actionAppearance={() => {}} tableHeaders={deviceHeaders} checkboxId={"uCheckDev"}
                                   parentComponent={"EventReports"} dData={dData} checkboxlist={devIdList}
                                   modal={false} editModal={() => {}} unk={"device-x-"}
                                   setCheckboxId={(value) => {setDevIdList(value)}} checkidkey={"device_id"} />);
    }, [devOriginData, devSorter, devIdList, devSearch]);

    useEffect(() => {
        let tmpData, searchKeys;

        searchKeys = ["device_category_short_name"];
        tmpData = searchFunc(devCatSearch, devCatOriginData, searchKeys);

        setDevCatDataCnt(tmpData.length);
        tmpData.sort((a, b) => sortFunc(a, b, devCatSorter.sortColumn, devCatSorter.sortOrder));
        setDevCatTableRows(<TableBody start={0} end={tmpData.length} tableData={tmpData} checkbox={true} writeAccess={true}
                                   actionAppearance={() => {}} tableHeaders={deviceCatHeaders} checkboxId={"uCheckDevCat"}
                                   parentComponent={"EventReports"} dData={dData} checkboxlist={devCatIdList}
                                   modal={false} editModal={() => {}} unk={"device-cat-x-"}
                                   setCheckboxId={(value) => {setDevCatIdList(value)}} checkidkey={"device_category_id"} />);
    }, [devCatOriginData, devCatSorter, devCatIdList, devCatSearch]);

    useEffect(() => {
        let tmpData, searchKeys;

        searchKeys = ["resident_first_name", "resident_last_name", "resident_nickname",
            ["resident_first_name", "resident_last_name"]];
        tmpData = searchFunc(resSearch, resOriginData, searchKeys);

        setResDataCnt(tmpData.length);
        tmpData.sort((a, b) => sortFunc(a, b, resSorter.sortColumn, resSorter.sortOrder));
        setResTableRows(<TableBody start={0} end={tmpData.length} tableData={tmpData} checkbox={true} writeAccess={true}
                                   actionAppearance={() => {}} tableHeaders={residentHeaders} checkboxId={"uCheckRes"}
                                   parentComponent={"EventReports"} dData={dData} checkboxlist={resIdList}
                                   modal={false} editModal={() => {}} unk={"resident-x-"} addlEditCheck={false}
                                   addlEditKey={""}
                                   setCheckboxId={(value) => {setResIdList(value)}} checkidkey={"resident_id"} />);
    }, [resOriginData, resSorter, resIdList, resSearch]);

    useEffect(() => {
        let tmpData, searchKeys;

        searchKeys = ["resident_group_name", "resident_description"];
        tmpData = searchFunc(residentGroupSearch, residentGroupOriginData, searchKeys);

        setResidentGroupDataCnt(tmpData.length);
        tmpData.sort((a, b) => sortFunc(a, b, residentGroupSorter.sortColumn, residentGroupSorter.sortOrder));
        setResidentGroupTableRows(<TableBody start={0} end={tmpData.length} tableData={tmpData} checkbox={true} writeAccess={true}
                                   actionAppearance={() => {}} tableHeaders={residentGroupHeaders} checkboxId={"uCheckResidentGroup"}
                                   parentComponent={"EventReports"} dData={dData} checkboxlist={residentGroupIdList}
                                   modal={false} editModal={() => {}} unk={"resident-group-x-"}
                                   setCheckboxId={(value) => {setResidentGroupIdList(value)}} checkidkey={"resident_group_id"} />);
    }, [residentGroupOriginData, residentGroupSorter, residentGroupIdList, residentGroupSearch]);

    useEffect(() => {
        let tmpData, searchKeys;

        searchKeys = ["event_type_name"];
        tmpData = searchFunc(eventTypeSearch, eventTypeOriginData, searchKeys);

        setEventTypeDataCnt(tmpData.length);
        tmpData.sort((a, b) => sortFunc(a, b, eventTypeSorter.sortColumn, eventTypeSorter.sortOrder));
        setEventTypeTableRows(<TableBody start={0} end={tmpData.length} tableData={tmpData} checkbox={true} writeAccess={true}
                                   actionAppearance={() => {}} tableHeaders={eventTypeHeaders} checkboxId={"uCheckType"}
                                   parentComponent={"EventReports"} dData={dData} checkboxlist={eventTypeIdList}
                                   modal={false} editModal={() => {}} unk={"event-type-x-"}
                                   setCheckboxId={(value) => {setEventTypeIdList(value)}} checkidkey={"event_type_id"} />);
    }, [eventTypeOriginData, eventTypeSorter, eventTypeIdList, eventTypeSearch]);

    useEffect(() => {
        let tmpData, searchKeys;

        searchKeys = ["username", "display_name", "user_role"];
        tmpData = searchFunc(userSearch, userOriginData, searchKeys);

        setUserDataCnt(tmpData.length);
        tmpData.sort((a, b) => sortFunc(a, b, userSorter.sortColumn, userSorter.sortOrder));
        setUserTableRows(<TableBody start={0} end={tmpData.length} tableData={tmpData} checkbox={true} writeAccess={true}
                                   actionAppearance={() => {}} tableHeaders={userHeaders} checkboxId={"uCheckUser"}
                                   parentComponent={"EventReports"} dData={dData} checkboxlist={userIdList}
                                   modal={false} editModal={() => {}} unk={"user-x-"}
                                   setCheckboxId={(value) => {setUserIdList(value)}} checkidkey={"user_id"} />);
    }, [userOriginData, userSorter, userIdList, userSearch]);

    useEffect(() => {
        let tmpData, searchKeys;

        searchKeys = ["group_name"];
        tmpData = searchFunc(userGroupSearch, userGroupOriginData, searchKeys);

        setUserGroupDataCnt(tmpData.length);
        tmpData.sort((a, b) => sortFunc(a, b, userGroupSorter.sortColumn, userGroupSorter.sortOrder));
        setUserGroupTableRows(<TableBody start={0} end={tmpData.length} tableData={tmpData} checkbox={true} writeAccess={true}
                                   actionAppearance={() => {}} tableHeaders={userGroupHeaders} checkboxId={"uCheckUserGroup"}
                                   parentComponent={"EventReports"} dData={dData} checkboxlist={userGroupIdList}
                                   modal={false} editModal={() => {}} unk={"user-Group-x-"}
                                   setCheckboxId={(value) => {setUserGroupIdList(value)}} checkidkey={"group_id"} />)
    }, [userGroupOriginData, userGroupSorter, userGroupIdList, userGroupSearch]);

    useEffect(() => {
        let tmpData, searchKeys;

        searchKeys = ["reason_code_description"];
        tmpData = searchFunc(reasonSearch, reasonOriginData, searchKeys);

        setReasonDataCnt(tmpData.length);
        tmpData.sort((a, b) => sortFunc(a, b, reasonSorter.sortColumn, reasonSorter.sortOrder));
        setReasonTableRows(<TableBody start={0} end={tmpData.length} tableData={tmpData} checkbox={true} writeAccess={true}
                                   actionAppearance={() => {}} tableHeaders={reasonHeaders} checkboxId={"uCheckReason"}
                                   parentComponent={"EventReports"} dData={dData} checkboxlist={reasonIdList}
                                   modal={false} editModal={() => {}} unk={"reason-x-"}
                                   setCheckboxId={(value) => {setReasonIdList(value)}} checkidkey={"reason_code_id"} />)
    }, [reasonOriginData, reasonSorter, reasonIdList, reasonSearch]);

    function clearSelectors(){
        for (let i=0; i < 31; i++){
            document.getElementById(`sch-monthly-meta-${i}`).checked = false;
        }
        for (let i2=0; i2 < 7; i2++){
            document.getElementById(`sch-weekly-meta-${i2}`).checked = false
        }
    }

    function editModal(editIndex){
        let dataIndex, freqId, entityList, tmp = [], selectorArray, rf, repItem;
        clearSelectors();
        dataIndex = parseInt(editIndex);
        setStoredIndex(dataIndex);
        rf = JSON.parse(activeData[dataIndex]?.report_filter_terms);
        setEditFilterAreas(![undefined, ""].includes(rf?.area_filter?.labels) ? rf.area_filter.labels : "");
        setAreaIdList(![undefined, ""].includes(rf?.area_filter?.values) ? rf.area_filter.values.split(",") : []);
        setEditFilterAreaGroups(![undefined, ""].includes(rf?.area_group_filter?.labels) ? rf.area_group_filter.labels : "");
        setAreaGroupIdList(![undefined, ""].includes(rf?.area_group_filter?.values) ? rf.area_group_filter.values.split(",") : []);
        setEditFilterAreaTypes(![undefined, ""].includes(rf?.area_type_filter?.labels) ? rf.area_type_filter.labels : "");
        setAreaTypeIdList(![undefined, ""].includes(rf?.area_type_filter?.values) ? rf.area_type_filter.values.split(",") : []);
        setEditFilterDevCat(![undefined, ""].includes(rf?.device_category_filter?.labels) ? rf.device_category_filter.labels : "");
        setDevCatIdList(![undefined, ""].includes(rf?.device_category_filter?.values) ? rf.device_category_filter.values.split(",") : []);
        setEditFilterDevice(![undefined, ""].includes(rf?.device_filter?.labels) ? rf.device_filter.labels : "");
        setDevIdList(![undefined, ""].includes(rf?.device_filter?.values) ? rf.device_filter.values.split(",") : []);
        setEditFilterRes(![undefined, ""].includes(rf?.resident_filter?.labels) ? rf.resident_filter.labels : "");
        setResIdList(![undefined, ""].includes(rf?.resident_filter?.values) ? rf.resident_filter.values.split(",") : []);
        setEditFilterResGroup(![undefined, ""].includes(rf?.resident_group_filter?.labels) ? rf.resident_group_filter.labels : "");
        setResidentGroupIdList(![undefined, ""].includes(rf?.resident_group_filter?.values) ? rf.resident_group_filter.values.split(",") : []);
        setEditFilterEventType(![undefined, ""].includes(rf?.event_type_filter?.labels) ? rf.event_type_filter.labels : "");
        setEventTypeIdList(![undefined, ""].includes(rf?.event_type_filter?.values) ? rf.event_type_filter.values.split(",") : []);
        setEditFilterUser(![undefined, ""].includes(rf?.user_filter?.labels) ? rf.user_filter.labels : "");
        setUserIdList(![undefined, ""].includes(rf?.user_filter?.values) ? rf.user_filter.values.split(",") : []);
        setEditFilterUserGroup(![undefined, ""].includes(rf?.user_group_filter?.labels) ? rf.user_group_filter.labels : "");
        setUserGroupIdList(![undefined, ""].includes(rf?.user_group_filter?.values) ? rf.user_group_filter.values.split(",") : [])
        setEditFilterReason(![undefined, ""].includes(rf?.reason_filter?.labels) ? rf.reason_filter.labels : "");
        setReasonIdList(![undefined, ""].includes(rf?.reason_filter?.values) ? rf.reason_filter.values.split(",") : []);
        console.log(rf?.resp_filter_items?.values)
        setResponseFilterList(![undefined, ""].includes(rf?.resp_filter_items?.values) ? rf.resp_filter_items.values : [false, "lt", 60])
        if (rf?.resp_filter_items?.values[0]){
            setEditFilterResponse(![undefined, ""].includes(rf?.resp_filter_items?.labels) ? rf.resp_filter_items.labels : "  ");
        }else{
            setEditFilterResponse("  ");
        }
        setNewEmails([]);
        entityList = activeData[dataIndex]?.report_receiver !== undefined ? activeData[dataIndex]?.report_receiver.split(",") : [];
        for (let i=0; i < entityList.length; i++){
            tmp.push({id: uuidv4(), email: entityList[i]});
        }
        setCurEmails(tmp);
        freqId = activeData[dataIndex]?.issue_freq_id;
        document.getElementById("sch-frequency").value = freqId;
        document.getElementById("sch-description").value = activeData[dataIndex]?.description;
        if (freqId.toString() === "1"){
            document.getElementById("sch-weekly").classList.add("d-none");
            document.getElementById("scheduler-container").classList.add("d-none");
            document.getElementById("sch-monthly").classList.add("d-none");
        }else if (freqId.toString() === "2"){
            document.getElementById("sch-weekly").classList.remove("d-none");
            document.getElementById("scheduler-container").classList.remove("d-none");
            document.getElementById("sch-monthly").classList.add("d-none");
            selectorArray = activeData[dataIndex]?.window_frequency_reference?.split(",");
            for (let i=0; i < selectorArray.length; i++){
                document.getElementById(`sch-weekly-meta-${selectorArray[i]}`).checked = true;
            }
        }else{
            document.getElementById("sch-monthly").classList.remove("d-none");
            document.getElementById("scheduler-container").classList.remove("d-none");
            document.getElementById("sch-weekly").classList.add("d-none");
            selectorArray = activeData[dataIndex]?.window_frequency_reference?.split(",");
            for (let i=0; i < selectorArray.length; i++){
                document.getElementById(`sch-monthly-meta-${selectorArray[i]}`).checked = true;
            }
        }
        document.getElementById("sch-sendTime").value = convertSectoHHMM(activeData[dataIndex].send_report_time);
        document.getElementById("add-pdf").checked = !!activeData[dataIndex].pdf_summary;
        document.getElementById("add-pdf2").checked = !!activeData[dataIndex].pdf_details;
        document.getElementById("add-csv").checked = !!activeData[dataIndex].csv_details;
        if (activeData[dataIndex].report_type_id === 5){
            document.getElementById("add-csv-container").classList.add("d-none");
        }else{
            document.getElementById("add-csv-container").classList.remove("d-none");
        }
        formCheck("editForm", "editSubmit");
        showModal("editmodal");
    }

    function showFilterModal(){
        // Function that preps and populates the filter modal with the checks when called based on stored session.
        document.getElementById("uCheckHead8").checked = areaIdList.length === areaOriginData.length;
        document.getElementById("uCheckHead9").checked = areaGroupIdList.length === areaGroupOriginData.length;
        document.getElementById("uCheckHead2").checked = areaTypeIdList.length === areaTypeOriginData.length;
        document.getElementById("uCheckHead3").checked = devCatIdList.length === devCatOriginData.length;
        document.getElementById("uCheckHead12").checked = devIdList.length === devOriginData.length;
        document.getElementById("uCheckHead4").checked = resIdList.length === resOriginData.length;
        document.getElementById("uCheckHead10").checked = residentGroupIdList.length === residentGroupOriginData.length;
        document.getElementById("uCheckHead5").checked = eventTypeIdList.length === eventTypeOriginData.length;
        document.getElementById("uCheckHead6").checked = userIdList.length === userOriginData.length;
        document.getElementById("uCheckHead11").checked = userGroupIdList.length === userGroupOriginData.length;
        document.getElementById("uCheckHead7").checked = reasonIdList.length === reasonOriginData.length;
        document.getElementById("response-on").checked = responseFilterList[0]
        document.getElementById("response-operator").value = responseFilterList[1]
        document.getElementById("response-value").value = responseFilterList[2]
        swapModal("cancelEditBtn", "filtermodal2");
    }

    function filterSubmit(){
        handleSubmitActions("filterSubmit", "loadFilterSubmit");
        setPerPage(tmpPerPage);
        setReportIdList([]);
        dData.perPage = tmpPerPage;
        setPage(1);
        setSession(dData);
        formSuccess("Page parameters stored to session.", "filterSubmit", "loadFilterSubmit", "cancelFilterBtn");
        setCount(0);
    }

    function deletePerform(submitBtn, loadBtn, closeId, start, end){
        let payload;
        handleSubmitActions(submitBtn, loadBtn);
        payload = [];
        for (let i=0; i < dContent.length; i++){
            payload.push({report_id: dContent[i][0], modified_by: dData.user});
        }
        ApiRequester({reqEndpoint: "mysave", Tbl: "core_report_definition", Payload: payload, urlType: "DELETE",
                            PKey: "report_id", Condition: "primary", CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
            if (data[0]){
                setCount(0);
                setReportIdList([]);
                formSuccess("Reports removed from system.", submitBtn, loadBtn, closeId);
                document.getElementById("uCheckHead").checked = false;
                checkAll(start, end);
                actionAppearance(start, end, ["deleteBtn"]);
            }
            else{
                formFail(`Failed to delete with error: ${data[1]}`, submitBtn, loadBtn);
            }
        });
    }

    function generateFilterTerms(){
        return {
            device_category_filter: {values: devCatIdList.join(","), labels: editFilterDevCat},
            device_filter: {values: devIdList.join(","), labels: editFilterDevice},
            area_filter: {values: areaIdList.join(","), labels: editFilterAreas},
            area_group_filter: {values: areaGroupIdList.join(","), labels: editFilterAreaGroups},
            area_type_filter: {values: areaTypeIdList.join(","), labels: editFilterAreaTypes},
            resident_filter: {values: resIdList.join(","), labels: editFilterRes},
            resident_group_filter: {values: residentGroupIdList.join(","), labels: editFilterResGroup},
            event_type_filter: {values: eventTypeIdList.join(","), labels: editFilterEventType},
            reason_filter: {values: reasonIdList.join(","), labels: editFilterReason},
            user_filter: {values: userIdList.join(","), labels: editFilterUser},
            user_group_filter: {values: userGroupIdList.join(","), labels: editFilterUserGroup},
            resp_filter_items: {values: responseFilterList, labels: editFilterResponse}
        }
    }

    function formEditSubmit(){
        // Location add form submit function
        let repId, emailList = [], payload, description, frequencyId, freqContainer, freqRate = [], sendTime, pdf, csv,
            nextSendTime, pdf2, filterTerms;
        handleSubmitActions("editSubmit", "loadEditSubmit");
        filterTerms = generateFilterTerms();
        repId = activeData[storedIndex].report_id;
        description = document.getElementById("sch-description").value;
        for (let i=0; i < curEmails.length; i++){
            emailList.push(curEmails[i].email);
        }
        for (let i2=0; i2 < newEmails.length; i2++){
            emailList.push(newEmails[i2].email);
        }
        frequencyId = parseInt(document.getElementById("sch-frequency").value);
        if (frequencyId === 1){
            freqRate.push(1);
        }else if (frequencyId === 2){
            freqContainer = document.getElementsByName("sch-weekly-meta");
            for (let i=0; i < freqContainer?.length; i++){
                if (freqContainer[i].checked){
                    freqRate.push(freqContainer[i].value);
                }
            }
        }else if (frequencyId === 3){
            freqContainer = document.getElementsByName("sch-monthly-meta");
            for (let i=0; i < freqContainer?.length; i++){
                if (freqContainer[i].checked){
                    freqRate.push(freqContainer[i].value);
                }
            }
        }
        sendTime = document.getElementById("sch-sendTime").value;
        nextSendTime = calculateSendTime(frequencyId, freqRate, sendTime,
            parseInt(dData?.campusData[campusId]?.tz_offset ? dData?.campusData[campusId]?.tz_offset : 0));
        pdf = document.getElementById("add-pdf")?.checked;
        pdf2 = document.getElementById("add-pdf2")?.checked;
        csv = document.getElementById("add-csv")?.checked;
        payload = [{report_id: repId, report_receiver: emailList.join(","), issue_freq_id: frequencyId,
                    window_frequency_reference: freqRate.join(","), next_send_time: nextSendTime,
                    description: description, send_report_time: convertHHMMtoSec(sendTime),
                    report_filter_terms: filterTerms,
                    pdf_summary: pdf ? 1 : 0, csv_details: csv ? 1 : 0, pdf_details: pdf2 ? 1 : 0}];
        ApiRequester({reqEndpoint: "mytransaction", TransType: "schedule_edit", Payload: payload,
                            CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
                if (data[0]){
                    setReportIdList([]);
                    formSuccess(`report updated.`, "editSubmit", "loadEditSubmit", "cancelEditBtn");
                    setCount(0)
                }
                else{
                    formFail(`Error during save, error code: ${data[1]}`, "editSubmit", "loadEditSubmit");
                }
        });
    }

    function filterSubmit2(){
        let areaTypeLabels = [], devCatLabels = [], resLabels = [], typeLabels = [], userLabels = [], reasonLabels = [],
            areaLabels = [], areaGroupLabels = [], residentGroupLabels = [], userGroupLabels = [], devLabels = [],
            respItems = ["", "", ""], respLabels = ["", "", ""];
        for (let i=0; i < areaOriginData?.length; i++){
            if (areaIdList.includes(areaOriginData[i]?.area_id?.toString())){
                areaLabels.push(areaOriginData[i]?.area_name);
            }
        }
        for (let i=0; i < areaGroupOriginData?.length; i++){
            if (areaGroupIdList.includes(areaGroupOriginData[i]?.area_group_id?.toString())){
                areaGroupLabels.push(areaGroupOriginData[i]?.area_group_name);
            }
        }
        for (let i=0; i < areaTypeOriginData?.length; i++){
            if (areaTypeIdList.includes(areaTypeOriginData[i]?.area_type_id?.toString())){
                areaTypeLabels.push(areaTypeOriginData[i]?.area_type_name);
            }
        }
        for (let i=0; i < devCatOriginData?.length; i++){
            if (devCatIdList.includes(devCatOriginData[i]?.device_category_id?.toString())){
                devCatLabels.push(devCatOriginData[i]?.device_category_short_name);
            }
        }
        for (let i=0; i < devOriginData?.length; i++){
            if (devIdList.includes(devOriginData[i]?.device_id?.toString())){
                devLabels.push(devOriginData[i]?.device_name);
            }
        }
        for (let i=0; i < resOriginData?.length; i++){
            if (resIdList.includes(resOriginData[i]?.resident_id?.toString())){
                resLabels.push(`${resOriginData[i]?.resident_first_name} ${resOriginData[i]?.resident_last_name}`);
            }
        }
        for (let i=0; i < residentGroupOriginData?.length; i++){
            if (resIdList.includes(residentGroupOriginData[i]?.resident_group_id?.toString())){
                residentGroupLabels.push(`${residentGroupOriginData[i]?.resident_group_name}`);
            }
        }
        for (let i=0; i < eventTypeOriginData?.length; i++){
            if (eventTypeIdList.includes(eventTypeOriginData[i]?.event_type_id?.toString())){
                typeLabels.push(eventTypeOriginData[i]?.event_type_name);
            }
        }
        for (let i=0; i < userOriginData?.length; i++){
            if (userIdList.includes(userOriginData[i]?.user_id?.toString())){
                userLabels.push(userOriginData[i]?.username);
            }
        }
        for (let i=0; i < userGroupOriginData?.length; i++){
            if (userGroupIdList.includes(userGroupOriginData[i]?.group_id?.toString())){
                userGroupLabels.push(userGroupOriginData[i]?.group_name);
            }
        }
        for (let i=0; i < reasonOriginData?.length; i++){
            if (reasonIdList.includes(reasonOriginData[i]?.reason_code_id?.toString())){
                reasonLabels.push(reasonOriginData[i]?.reason_code_description);
            }
        }

        respItems[0] = document.getElementById("response-on").checked;
        respItems[1] = document.getElementById("response-operator").value;
        respItems[2] = document.getElementById("response-value").value;

        if (respItems[0]){
            respLabels[0] = "Response Time";
            if (respItems[1] === "lt"){
                respLabels[1] = "less than";
            }else if (respItems[1] === "gt"){
                respLabels[1] = "greater than";
            }else{
                respLabels[1] = "equal to";
            }
            respLabels[2] = respItems[2].toString();
        }

        setEditFilterAreas(areaLabels.join(","));
        setEditFilterAreaGroups(areaGroupLabels.join(","));
        setEditFilterAreaTypes(areaTypeLabels.join(","));
        setEditFilterRes(resLabels.join(","));
        setEditFilterResGroup(resLabels.join(","));
        setEditFilterDevCat(devCatLabels.join(","));
        setEditFilterDevice(devLabels.join(","));
        setEditFilterUser(userLabels.join(","));
        setEditFilterUserGroup(userGroupLabels.join(","));
        setEditFilterReason(reasonLabels.join(","));
        setEditFilterEventType(typeLabels.join(","));
        setEditFilterResGroup(residentGroupLabels.join(","));
        setEditFilterResponse(respLabels.join(" "));
        document.getElementById("cancelFilterBtn2").click();
    }

    function sendReport(rowIndex){
        let payload, description;
        handleSubmitActions(`icon-btn-${rowIndex}`, `load-icon-btn-${rowIndex}`);
        description = activeData[parseInt(rowIndex)]?.description
        payload = [{
            campus_id: activeData[parseInt(rowIndex)]?.campus_id ? activeData[parseInt(rowIndex)]?.campus_id : campusId,
            description: description,
            source: "portal",
            report_id: activeData[parseInt(rowIndex)]?.report_id,
            report_filter_terms: activeData[parseInt(rowIndex)]?.report_filter_terms,
            report_interval_id: activeData[parseInt(rowIndex)]?.report_interval_id,
            report_receiver: activeData[parseInt(rowIndex)]?.report_receiver,
            report_type_id: activeData[parseInt(rowIndex)]?.report_type_id,
            last_sent: activeData[parseInt(rowIndex)]?.last_sent,
            pdf_summary: activeData[parseInt(rowIndex)]?.pdf_summary,
            csv_details: activeData[parseInt(rowIndex)]?.csv_details,
            pdf_details: activeData[parseInt(rowIndex)]?.pdf_details
        }]
        ApiRequester({reqEndpoint: "send_report", Payload: payload, CampusId: campusId,
                            ClientId: dData.sessionId, nowait: true}).then(data => {
            if (data[0]){
                formSuccess(`Report ${description} sent successfully`, `icon-btn-${rowIndex}`, `load-icon-btn-${rowIndex}`);
            }
            else{
                formFail("Failed to send report, contact support if failure continues.", `icon-btn-${rowIndex}`, `load-icon-btn-${rowIndex}`);
            }
        });
    }

    function eventFiltersOn(){
        return [areaIdList, reasonIdList].some(filterArray => filterArray.length > 0) || responseFilterList[0];
    }

    function areaFiltersOn(){
        return [areaIdList, areaGroupIdList, areaTypeIdList].some(filterArray => filterArray.length > 0);
    }

    function resFiltersOn(){
        return [resIdList, residentGroupIdList].some(filterArray => filterArray.length > 0);
    }

    function userFiltersOn(){
        return [userIdList, userGroupIdList].some(filterArray => filterArray.length > 0);
    }

    function deviceFiltersOn(){
        return [devCatIdList, devIdList].some(filterArray => filterArray.length > 0);
    }

    const areaTableHeaders = <TableHeaders checkbox={true} headerData={areaHeaders} checkboxlist={areaIdList}
                                               checkAll={() => checkAll(0, areaDataCnt ? areaDataCnt : 0, areaIdList, setAreaIdList, "uCheckHead8", "uCheckArea")}
                                               writeAccess={true} sortOrder={areaSorter.sortOrder} checkboxHeaderId={"uCheckHead8"}
                                               sortColumn={areaSorter.sortColumn} sorter={areaSorter} setSorter={setAreaSorter}
                                               actionAppearance={() => {}} />
    const areaGroupTableHeaders = <TableHeaders checkbox={true} headerData={areaGroupHeaders} checkboxlist={areaGroupIdList}
                                               checkAll={() => checkAll(0, areaGroupDataCnt ? areaGroupDataCnt : 0, areaGroupIdList, setAreaGroupIdList, "uCheckHead9", "uCheckAreaGroup")}
                                               writeAccess={true} sortOrder={areaGroupSorter.sortOrder} checkboxHeaderId={"uCheckHead9"}
                                               sortColumn={areaGroupSorter.sortColumn} sorter={areaGroupSorter} setSorter={setAreaGroupSorter}
                                               actionAppearance={() => {}} />
    const areaTypeTableHeaders = <TableHeaders checkbox={true} headerData={areaTypeHeaders} checkboxlist={areaTypeIdList}
                                               checkAll={() => checkAll(0, areaTypeDataCnt ? areaTypeDataCnt : 0, areaTypeIdList, setAreaTypeIdList, "uCheckHead2", "uCheckAreaType")}
                                               writeAccess={true} sortOrder={areaTypeSorter.sortOrder} checkboxHeaderId={"uCheckHead2"}
                                               sortColumn={areaTypeSorter.sortColumn} sorter={areaTypeSorter} setSorter={setAreaTypeSorter}
                                               actionAppearance={() => {}} />
    const deviceCatTableHeaders = <TableHeaders checkbox={true} headerData={deviceCatHeaders} checkboxlist={devCatIdList}
                                                checkAll={() => checkAll(0, devCatDataCnt ? devCatDataCnt : 0, devCatIdList, setDevCatIdList, "uCheckHead3", "uCheckDevCat")}
                                                writeAccess={true} sortOrder={devCatSorter.sortOrder} checkboxHeaderId={"uCheckHead3"}
                                                sortColumn={devCatSorter.sortColumn} sorter={devCatSorter} setSorter={setDevCatSorter}
                                                actionAppearance={() => {}} />
    const deviceTableHeaders = <TableHeaders checkbox={true} headerData={deviceHeaders} checkboxlist={devIdList}
                                             checkAll={() => checkAll(0, devDataCnt ? devDataCnt : 0, devIdList, setDevIdList, "uCheckHead12", "uCheckDev")}
                                             writeAccess={true} sortOrder={devSorter.sortOrder} checkboxHeaderId={"uCheckHead12"}
                                             sortColumn={devSorter.sortColumn} sorter={devSorter} setSorter={setDevSorter}
                                             actionAppearance={() => {}} />
    const residentTableHeaders = <TableHeaders checkbox={true} headerData={residentHeaders} checkboxlist={resIdList}
                                             checkAll={() => checkAll(0, resDataCnt ? resDataCnt : 0, resIdList, setResIdList, "uCheckHead4", "uCheckRes")}
                                             writeAccess={true} sortOrder={resSorter.sortOrder} checkboxHeaderId={"uCheckHead4"}
                                             sortColumn={resSorter.sortColumn} sorter={resSorter} setSorter={setResSorter}
                                             actionAppearance={() => {}} />
    const residentGroupTableHeaders = <TableHeaders checkbox={true} headerData={residentGroupHeaders} checkboxlist={residentGroupIdList}
                                             checkAll={() => checkAll(0, residentGroupDataCnt ? residentGroupDataCnt : 0, residentGroupIdList, setResidentGroupIdList, "uCheckHead10", "uCheckResidentGroup")}
                                             writeAccess={true} sortOrder={residentGroupSorter.sortOrder} checkboxHeaderId={"uCheckHead10"}
                                             sortColumn={residentGroupSorter.sortColumn} sorter={residentGroupSorter} setSorter={setResidentGroupSorter}
                                             actionAppearance={() => {}} />
    const eventTypeTableHeaders = <TableHeaders checkbox={true} headerData={eventTypeHeaders} checkboxlist={eventTypeIdList}
                                             checkAll={() => checkAll(0, eventTypeDataCnt ? eventTypeDataCnt : 0, eventTypeIdList, setEventTypeIdList, "uCheckHead5", "uCheckType")}
                                             writeAccess={true} sortOrder={eventTypeSorter.sortOrder} checkboxHeaderId={"uCheckHead5"}
                                             sortColumn={eventTypeSorter.sortColumn} sorter={eventTypeSorter} setSorter={setEventTypeSorter}
                                             actionAppearance={() => {}} />
    const userTableHeaders = <TableHeaders checkbox={true} headerData={userHeaders} checkboxlist={userIdList}
                                             checkAll={() => checkAll(0, userDataCnt ? userDataCnt : 0, userIdList, setUserIdList, "uCheckHead6", "uCheckUser")}
                                             writeAccess={true} sortOrder={userSorter.sortOrder} checkboxHeaderId={"uCheckHead6"}
                                             sortColumn={userSorter.sortColumn} sorter={userSorter} setSorter={setUserSorter}
                                             actionAppearance={() => {}} />
    const userGroupTableHeaders = <TableHeaders checkbox={true} headerData={userGroupHeaders} checkboxlist={userGroupIdList}
                                                checkAll={() => checkAll(0, userGroupDataCnt ? userGroupDataCnt : 0, userGroupIdList, setUserGroupIdList, "uCheckHead11", "uCheckUserGroup")}
                                                writeAccess={true} sortOrder={userGroupSorter.sortOrder} checkboxHeaderId={"uCheckHead11"}
                                                sortColumn={userGroupSorter.sortColumn} sorter={userGroupSorter} setSorter={setUserGroupSorter}
                                                actionAppearance={() => {}} />
    const reasonTableHeaders = <TableHeaders checkbox={true} headerData={reasonHeaders} checkboxlist={reasonIdList}
                                             checkAll={() => checkAll(0, reasonDataCnt ? reasonDataCnt : 0, reasonIdList, setReasonIdList, "uCheckHead7", "uCheckReason")}
                                             writeAccess={true} sortOrder={reasonSorter.sortOrder} checkboxHeaderId={"uCheckHead7"}
                                             sortColumn={reasonSorter.sortColumn} sorter={reasonSorter} setSorter={setReasonSorter}
                                             actionAppearance={() => {}} />

    const tableHeaders = <TableHeaders checkbox={true} headerData={headerData} checkAll={() => checkAll(ppRules.start, ppRules.end, reportIdList, setReportIdList)}
                                       writeAccess={editable} sortOrder={sorter.sortOrder} modal={true} modal_name={"Edit"} setPage={setPage}
                                       sortColumn={sorter.sortColumn} sorter={sorter} setSorter={setSorter} actionIcon={true}
                                       iconAction={(rowId) => sendReport(rowId)} checkboxlist={reportIdList} action_name={"Send"}
                                       actionAppearance={() => actionAppearance(ppRules.start, ppRules.end, ["deleteBtn"])}
                                       headerFiltersOn={true} headerFilters={headerFilters} setHeaderFilters={setHeaderFilters} originData={dataOrigin}/>

    const headerContent = (
        <div className={"d-flex justify-content-between"}>
            <div style={{minWidth: "360px"}}>
                {editable && <Button text={"Disable"} type={"button"} class={"btn btn-danger ms-2 hide mt-1"}
                                     id={"deleteBtn"} icon={true} iconClass={"fe fe-trash-2 me-2"}
                                     onClick={() => bulkDeleteModal(ppRules.start, ppRules.end, activeData, "report_type_name", ["report_id", ""], "", setDContent)} />}
                <div className={"form-outline d-inline-flex align-bottom ms-2"}>
                    <input type={"search"} id={"search1"} className={"form-control search-input mt-1"}
                         onKeyUp={(e) => setSearch(e.target.value)} />
                    <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left mt-1"} style={{height: "42px"}}
                            icon={true} iconClass={"fe fe-search"}/>
                </div>
                {csvButton}
            </div>
            <CampusDropDown campusId={campusId} setCampusId={(item) => setCampusId(item)} setCount={(item) => setCount(item)} pageAction={() => {}}/>
        </div>
    );

    const footer = (
        <div>
            <Pagination>
                <PaginationItems setPage={setPage} page={page} beginDot={ppRules.beginDot}
                                 endDot={ppRules.endDot} pageMin={ppRules.pageMin} pageMax={ppRules.pageMax}
                                 max={ppRules.max}/>
            </Pagination>
            <Button class={"btn btn-secondary fs-5 ms-4"} text={perPage} onClick={() => showModal("filtermodal")}/>
        </div>
    );

    return (
        <>
            <Navigation />
            <div className={"main-content"}>
                <Header preTitle={"Scheduled Reports"} Title={"Schedules"} content={headerContent}/>
                <div className={"container-fluid mt-4"}>
                    {!pageLoaded
                        ? skeleton
                        :   <>
                                <div className={"d-flex justify-content-end mb-2"}>
                                    <span className={"text-muted"} style={{fontSize: "var(--font-size-sm)"}}>
                                        Showing <strong>{Math.min(ppRules.start+1, dataOrigin.length)}</strong> - <strong>{Math.min(ppRules.end+1, dataOrigin.length)}</strong> of <strong>{dataOrigin.length}</strong> {dataOrigin.length === 1 ? "report" : "reports"}
                                    </span>
                                </div>
                                <table className={"table table-sm table-white table-hover"}>
                                    <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                                    {tableHeaders}
                                    </thead>
                                    <tbody id={"tBody"}>
                                    {tableRows}
                                    </tbody>
                                </table>
                            </>
                    }
                    <div className={"footer-spacer"}></div>
                </div>
                <Footer center={footer}/>
            </div>
            <div className={"modal fade"} id={"editmodal"} data-bs-backdrop={"static"}
                 data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title text-capitalize"} id={"staticBackdropLabel"}>Edit Recipients</h2>
                            <button type={"button"} className={"btn-close"} id={"editClose"}
                                    data-bs-dismiss={"modal"} aria-label={"Close"}/>
                        </div>
                        <form id={"editForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <h5>* To change contents of a scheduled report, delete current report and re-create from
                                    the report page.</h5>
                                <div className={"form-floating mb-3"}>
                                    <input type={"text"} className={"form-control"} id={"sch-description"}
                                           onKeyUp={() => formCheck("editForm", "editSubmit")}
                                           required={true} pattern={"^[0-9a-zA-Z_@\\- ]+$"}/>
                                    <label htmlFor={"sch-description"}>Description</label>
                                </div>
                                <div className={"d-flex justify-content-around"}>
                                    <div className={"form-floating mb-3 me-3 w-75"}>
                                        <select className={"form-select"} required={true} id={"sch-frequency"}
                                                defaultValue={""}
                                                onChange={(e) => {
                                                    if (e.target.value.toString() === "1") {
                                                        document.getElementById("sch-weekly").classList.add("d-none");
                                                        document.getElementById("scheduler-container").classList.add("d-none");
                                                        document.getElementById("sch-monthly").classList.add("d-none");
                                                    } else if (e.target.value.toString() === "2") {
                                                        document.getElementById("sch-weekly").classList.remove("d-none");
                                                        document.getElementById("scheduler-container").classList.remove("d-none");
                                                        document.getElementById("sch-monthly").classList.add("d-none");
                                                    } else {
                                                        document.getElementById("sch-monthly").classList.remove("d-none");
                                                        document.getElementById("scheduler-container").classList.remove("d-none");
                                                        document.getElementById("sch-weekly").classList.add("d-none");
                                                    }
                                                    formCheck("editForm", "editSubmit");
                                                }}>
                                            <option value={""} disabled={true}></option>
                                            {freqOptions}
                                        </select>
                                        <label htmlFor={"sch-frequency"}>Delivery Rate</label>
                                    </div>
                                    <div className={"form-floating mb-3"}>
                                        <input type={"time"} className={"form-control"} id={"sch-sendTime"}
                                               required={true} step={"300"} min={"00:00"} max={"23:59"}
                                               onFocus={(e) => {
                                                   e.target.showPicker();
                                               }}
                                               onBlur={(e) => {
                                                   if (!e.target.checkValidity()) {
                                                       e.target.stepUp();
                                                   }
                                                   formCheck("editForm", "editSubmit");
                                               }}/>
                                        <label htmlFor={"sch-sendTime"}>Time of Day</label>
                                    </div>
                                </div>
                                <div className={"d-inline-block"}>
                                    <div className={"form-check"}>
                                        <label htmlFor={"add-pdf"}>Add PDF Attachment (Summary)</label>
                                        <input id={"add-pdf"} defaultChecked={false}
                                               className={"form-check-input"} type={"checkbox"}/>
                                    </div>
                                    <div className={"form-check"}>
                                            <label htmlFor={"add-pdf2"}>Add PDF Attachment (Details)</label>
                                            <input id={"add-pdf2"} defaultChecked={false}
                                                   className={"form-check-input"} type={"checkbox"}/>
                                        </div>
                                    <div className={"form-check"} id={"add-csv-container"}>
                                        <label htmlFor={"add-csv"}>Add CSV Attachment (Details)</label>
                                        <input id={"add-csv"} defaultChecked={false}
                                               className={"form-check-input"} type={"checkbox"}/>
                                    </div>
                                </div>
                                <fieldset className={"border py-3 px-3 mt-4 d-none"} style={{borderRadius: "6px"}}
                                          id={"scheduler-container"}>
                                    <legend className={"fs-3 px-3 w-auto mb-0 legend"} style={{
                                        backgroundColor: "#FFFFFF",
                                        position: "relative",
                                        bottom: "26px"
                                    }}>Delivery Schedule
                                    </legend>
                                    <div id={"sch-weekly"} className={"d-none"}>
                                        <ul style={{columns: 3, listStyle: "none", columnGap: "30px"}}
                                            className={"float-start"}>
                                            <li>
                                                <div className={"form-check"}>
                                                    <label htmlFor={"sch-weekly-meta-0"}>Monday</label>
                                                    <input name={"sch-weekly-meta"} id={"sch-weekly-meta-0"} value={0}
                                                           defaultChecked={false} className={"form-check-input"}
                                                           type={"checkbox"}/>
                                                </div>
                                            </li>
                                            <li>
                                                <div className={"form-check"}>
                                                    <label htmlFor={"sch-weekly-meta-1"}>Tuesday</label>
                                                    <input name={"sch-weekly-meta"} id={"sch-weekly-meta-1"} value={1}
                                                           defaultChecked={false} className={"form-check-input"}
                                                           type={"checkbox"}/>
                                                </div>
                                            </li>
                                            <li>
                                                <div className={"form-check"}>
                                                    <label htmlFor={"sch-weekly-meta-2"}>Wednesday</label>
                                                    <input name={"sch-weekly-meta"} id={"sch-weekly-meta-2"} value={2}
                                                           defaultChecked={false} className={"form-check-input"}
                                                           type={"checkbox"}/>
                                                </div>
                                            </li>
                                            <li>
                                                <div className={"form-check"}>
                                                    <label htmlFor={"sch-weekly-meta-3"}>Thursday</label>
                                                    <input name={"sch-weekly-meta"} id={"sch-weekly-meta-3"} value={3}
                                                           defaultChecked={false} className={"form-check-input"}
                                                           type={"checkbox"}/>
                                                </div>
                                            </li>
                                            <li>
                                                <div className={"form-check"}>
                                                    <label htmlFor={"sch-weekly-meta-4"}>Friday</label>
                                                    <input name={"sch-weekly-meta"} id={"sch-weekly-meta-4"} value={4}
                                                           defaultChecked={false} className={"form-check-input"}
                                                           type={"checkbox"}/>
                                                </div>
                                            </li>
                                            <li>
                                                <div className={"form-check"}>
                                                    <label htmlFor={"sch-weekly-meta-5"}>Saturday</label>
                                                    <input name={"sch-weekly-meta"} id={"sch-weekly-meta-5"} value={5}
                                                           defaultChecked={false} className={"form-check-input"}
                                                           type={"checkbox"}/>
                                                </div>
                                            </li>
                                            <li>
                                                <div className={"form-check"}>
                                                    <label htmlFor={"sch-weekly-meta-6"}>Sunday</label>
                                                    <input name={"sch-weekly-meta"} id={"sch-weekly-meta-6"} value={6}
                                                           defaultChecked={false} className={"form-check-input"}
                                                           type={"checkbox"}/>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div id={"sch-monthly"} className={"d-none"}>
                                        <ul style={{columns: 4, listStyle: "none", columnGap: "30px"}}
                                            className={"float-start"}>
                                            {Array.from(range(1, 30)).map((i) => {
                                                return (
                                                    <li key={`monthly-rate-item-${i}`}>
                                                        <div className={"form-check"}>
                                                            <label htmlFor={`sch-monthly-meta-${i}`}>{i}</label>
                                                            <input name={"sch-monthly-meta"}
                                                                   id={`sch-monthly-meta-${i}`} value={i}
                                                                   defaultChecked={false}
                                                                   className={"form-check-input"} type={"checkbox"}/>
                                                        </div>
                                                    </li>
                                                );
                                            })}
                                            <li>
                                                <div className={"form-check"}>
                                                    <label htmlFor={"sch-monthly-meta-0"}>Last Day</label>
                                                    <input name={"sch-monthly-meta"} id={"sch-monthly-meta-0"} value={0}
                                                           defaultChecked={false}
                                                           className={"form-check-input"} type={"checkbox"}/>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </fieldset>
                                <hr className={"mt-5 mb-3"}/>
                                <fieldset className={"border py-3 px-3 mt-4"} style={{borderRadius: "6px"}}>
                                    <legend className={"fs-3 px-3 w-auto mb-0 legend"} style={{
                                        backgroundColor: "#FFFFFF",
                                        position: "relative",
                                        bottom: "26px"
                                    }}>Applied Filters
                                        <button type={"button"} className={"btn btn-secondary ms-3"} style={{height: "45px"}}
                                            onClick={() => {
                                                showFilterModal();
                                            }}><i className={"fe fe-filter fs-3"}/>
                                    </button>
                                    </legend>
                                    <ul className={"ps-3"} style={{listStyle: "none"}} id={"filteritems"}>
                                        {editFilterAreas !== "" && <li>
                                            <span className={"d-inline-block"}
                                                  style={{width: "125px"}}>Areas: </span>
                                            <span>{editFilterAreas}</span>
                                        </li>}
                                        {editFilterAreaGroups !== "" && <li>
                                            <span className={"d-inline-block"}
                                                  style={{width: "125px"}}>Area Groups: </span>
                                            <span>{editFilterAreaGroups}</span>
                                        </li>}
                                        {editFilterAreaTypes !== "" && <li>
                                            <span className={"d-inline-block"}
                                                  style={{width: "125px"}}>Area Types: </span>
                                            <span>{editFilterAreaTypes}</span>
                                        </li>}
                                        {editFilterRes !== "" && <li>
                                            <span className={"d-inline-block"}
                                                  style={{width: "125px"}}>Residents: </span>
                                            <span>{editFilterRes}</span>
                                        </li>}
                                        {editFilterResGroup !== "" && <li>
                                            <span className={"d-inline-block"}
                                                  style={{width: "125px"}}>Resident Groups: </span>
                                            <span>{editFilterResGroup}</span>
                                        </li>}
                                        {editFilterUser !== "" && <li>
                                            <span className={"d-inline-block"}
                                                  style={{width: "125px"}}>Users: </span>
                                            <span>{editFilterUser}</span>
                                        </li>}
                                        {editFilterUserGroup !== "" && <li>
                                            <span className={"d-inline-block"}
                                                  style={{width: "125px"}}>User Groups: </span>
                                            <span>{editFilterUserGroup}</span>
                                        </li>}
                                        {editFilterDevice !== "" && <li>
                                            <span className={"d-inline-block"}
                                                  style={{width: "125px"}}>Devices: </span>
                                            <span>{editFilterDevice}</span>
                                        </li>}
                                        {editFilterDevCat !== "" && <li>
                                            <span className={"d-inline-block"}
                                                  style={{width: "125px"}}>Device Categories: </span>
                                            <span>{editFilterDevCat}</span>
                                        </li>}
                                        {editFilterEventType !== "" && <li>
                                            <span className={"d-inline-block"}
                                                  style={{width: "125px"}}>Event Types: </span>
                                            <span>{editFilterEventType}</span>
                                        </li>}
                                        {editFilterReason !== "" && <li>
                                            <span className={"d-inline-block"}
                                                  style={{width: "125px"}}>Reasons: </span>
                                            <span>{editFilterReason}</span>
                                        </li>}
                                        {editFilterResponse !== "  " && <li>
                                            <span className={"d-inline-block"}
                                                  style={{width: "125px"}}>Response: </span>
                                            <span>{editFilterResponse}</span>
                                        </li>}
                                    </ul>
                                </fieldset>
                                <hr className={"my-5"}/>
                                <div className={"list-group-item"}>
                                    <Button type={"button"} class={"btn btn-primary mb-3"} text={"New Email"}
                                            onClick={() => {
                                                setNewEmails((prevState) => {
                                                    return [...prevState, {id: uuidv4(), email: ""}]
                                                });
                                            }}/>
                                    {newEmails.map((item) => {
                                        return (
                                            <div key={`new-email-item${item.id}`}>
                                                <i className={"fe fe-trash as-btn d-inline-block red-hover"}
                                                   onClick={() => {
                                                       setNewEmails((prevState) => {
                                                           return prevState.filter(i => i.id !== item.id);
                                                       });
                                                       formCheck("editForm", "editSubmit");
                                                   }}></i>
                                                <div className={"form-floating d-inline-block w-75 mb-3 mx-3"}>
                                                    <input type={"text"} name={"email-input"}
                                                           className={"form-control"}
                                                           id={`new-email-${item.id}`}
                                                           onKeyUp={(e) => {
                                                               setNewEmails((prevState) => {
                                                                   return prevState.map((i) => {
                                                                       if (i.id === item.id) {
                                                                           return {
                                                                               id: i.id,
                                                                               email: e.target.value
                                                                           };
                                                                       }
                                                                       return i;
                                                                   });
                                                               })
                                                               formCheck("editForm", "editSubmit");
                                                           }} required={true}
                                                           pattern={"[a-z0-9._%+\\-]+@[a-z0-9.\\-]+\\.[a-z]{2,}$"}
                                                           defaultValue={item.email}/>
                                                    <label htmlFor={`new-email-${item.id}`}>Email
                                                        Address</label>
                                                </div>
                                            </div>);
                                    })}
                                </div>
                                <hr/>
                                <div className={"list-group-item"}>
                                    {curEmails.map((item) => {
                                        return (
                                            <div key={`stored-email-${item.id}`}>
                                                <i className={"fe fe-trash as-btn d-inline-block red-hover"}
                                                   onClick={() => {
                                                       setCurEmails((prevState) => {
                                                           return prevState.filter(i => i?.id !== item.id);
                                                       })
                                                   }}></i>
                                                <div className={"form-floating d-inline-block w-75 mb-3 mx-3"}>
                                                    <input type={"text"} name={"email-input"}
                                                           className={"form-control"}
                                                           id={`tmp-email-${item.id}`} required={true}
                                                           pattern={"[a-z0-9._%+\\-]+@[a-z0-9.\\-]+\\.[a-z]{2,}$"}
                                                           value={item.email} readOnly={true}/>
                                                    <label htmlFor={`tmp-email-${item.id}`}>Email
                                                        Address</label>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                            <div className={"modal-footer"}>
                                <div>
                                    <button type={"button"} className={"btn btn-secondary"} id={"cancelEditBtn"}
                                            data-bs-dismiss={"modal"}>Cancel
                                    </button>
                                    <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                            spinner={true} text={"Loading"} id={"loadEditSubmit"}/>
                                    <button type={"button"} className={"btn btn-primary ms-3"}
                                            onClick={() => formEditSubmit()} id={"editSubmit"}>Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"filtermodal2"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                     tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Filter Settings</h2>
                            <Button text={"Clear All"} class={"btn ms-3 pb-0 hover-text-white"}
                                    onClick={() => clearFilters()}/>
                            <button type={"button"} className={"btn-close"} id={"filterClose2"}
                                    data-bs-dismiss={"modal"} aria-label={"Close"}/>
                        </div>
                        <form id={"filterForm2"}>
                            <div className={"modal-body pt-3"}>
                                <div className={"row align-items-center"}
                                     style={{borderBottom: "dotted 1px var(--color-border-medium)"}}>
                                    <div className={"col"}>
                                        <ul className={"nav nav-tabs nav-overflow header-tabs mb-0"}>
                                            <li className={"mx-1 my-2 d-flex"}>
                                                <Button text={"Areas"}
                                                        class={tabCat === "areas" ? "btn btn-toggle btn-active-primary" : "btn btn-toggle"}
                                                        style={{width: "95px"}}
                                                        onClick={() => {
                                                            setTabCat("areas");
                                                            setTabItem("area");
                                                        }}/>
                                                {areaFiltersOn() && <div className={"filter-caret"}></div>}
                                            </li>
                                            <li className={"mx-1 my-2 d-flex"}>
                                                <Button text={"Residents"}
                                                        class={tabCat === "residents" ? "btn btn-toggle btn-active-primary" : "btn btn-toggle"}
                                                        style={{width: "95px"}}
                                                        onClick={() => {
                                                            setTabCat("residents");
                                                            setTabItem("resident");
                                                        }}/>
                                                {resFiltersOn() && <div className={"filter-caret"}></div>}
                                            </li>
                                            <li className={"mx-1 my-2 d-flex"}>
                                                <Button text={"Users"}
                                                        class={tabCat === "users" ? "btn btn-toggle btn-active-primary" : "btn btn-toggle"}
                                                        style={{width: "95px"}}
                                                        onClick={() => {
                                                            setTabCat("users");
                                                            setTabItem("user");
                                                        }}/>
                                                {userFiltersOn() && <div className={"filter-caret"}></div>}
                                            </li>
                                            <li className={"mx-1 my-2 d-flex"}>
                                                <Button text={"Devices"}
                                                        class={tabCat === "devices" ? "btn btn-toggle btn-active-primary" : "btn btn-toggle"}
                                                        style={{width: "95px"}}
                                                        onClick={() => {
                                                            setTabCat("devices");
                                                            setTabItem("deviceCat");
                                                        }}/>
                                                {deviceFiltersOn() && <div className={"filter-caret"}></div>}
                                            </li>
                                            <li className={"mx-1 my-2 d-flex"}>
                                                <Button text={"Events"}
                                                        class={tabCat === "events" ? "btn btn-toggle btn-active-primary" : "btn btn-toggle"}
                                                        style={{width: "95px"}}
                                                        onClick={() => {
                                                            setTabCat("events");
                                                            setTabItem("event");
                                                        }}/>
                                                {eventFiltersOn() && <div className={"filter-caret"}></div>}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className={"mt-2"}>
                                    <div>
                                        {tabCat === "areas"
                                            ? <ul className={"nav nav-tabs nav-overflow header-tabs"}>
                                                <li className={"nav-item"}>
                                                    <Button text={"Area"} id={"area-filter-tab"}
                                                            class={tabItem === "area" ? "nav-link active" : "nav-link"}
                                                            onClick={() => setTabItem("area")}/>
                                                </li>
                                                <li className={"nav-item"}>
                                                    <Button text={"Area Groups"} id={"area-group-filter-tab"}
                                                            class={tabItem === "areaGroup" ? "nav-link active" : "nav-link"}
                                                            onClick={() => setTabItem("areaGroup")}/>
                                                </li>
                                                <li className={"nav-item"}>
                                                    <Button text={"Area Types"} id={"area-type-filter-tab"}
                                                            class={tabItem === "areaType" ? "nav-link active" : "nav-link"}
                                                            onClick={() => setTabItem("areaType")}/>
                                                </li>
                                            </ul>
                                            : <></>
                                        }
                                        {tabCat === "residents"
                                            ? <ul className={"nav nav-tabs nav-overflow header-tabs"}>
                                                <li className={"nav-item"}>
                                                    <Button text={"Resident"} id={"resident-filter-tab"}
                                                            class={tabItem === "resident" ? "nav-link active" : "nav-link"}
                                                            onClick={() => setTabItem("resident")}/>
                                                </li>
                                                <li className={"nav-item"}>
                                                    <Button text={"Resident Groups"} id={"resident-group-filter-tab"}
                                                            class={tabItem === "residentGroup" ? "nav-link active" : "nav-link"}
                                                            onClick={() => setTabItem("residentGroup")}/>
                                                </li>
                                            </ul>
                                            : <></>
                                        }
                                        {tabCat === "users"
                                            ? <ul className={"nav nav-tabs nav-overflow header-tabs"}>
                                                <li className={"nav-item"}>
                                                    <Button text={"User"} id={"user-filter-tab"}
                                                            class={tabItem === "user" ? "nav-link active" : "nav-link"}
                                                            onClick={() => setTabItem("user")}/>
                                                </li>
                                                <li className={"nav-item"}>
                                                    <Button text={"User Groups"} id={"user-group-filter-tab"}
                                                            class={tabItem === "userGroup" ? "nav-link active" : "nav-link"}
                                                            onClick={() => setTabItem("userGroup")}/>
                                                </li>
                                            </ul>
                                            : <></>
                                        }
                                        {tabCat === "devices"
                                            ? <ul className={"nav nav-tabs nav-overflow header-tabs"}>
                                                <li className={"nav-item"}>
                                                    <Button text={"Device Categories"} id={"device-cat-filter-tab"}
                                                            class={tabItem === "deviceCat" ? "nav-link active" : "nav-link"}
                                                            onClick={() => setTabItem("deviceCat")}/>
                                                </li>
                                                <li className={"nav-item"}>
                                                    <Button text={"Devices"} id={"device-filter-tab"}
                                                            class={tabItem === "device" ? "nav-link active" : "nav-link"}
                                                            onClick={() => setTabItem("device")}/>
                                                </li>
                                            </ul>
                                            : <></>
                                        }
                                        {tabCat === "events"
                                            ? <ul className={"nav nav-tabs nav-overflow header-tabs"}>
                                                <li className={"nav-item"}>
                                                    <Button text={"Event Types"} id={"event-type-filter-tab"}
                                                            class={tabItem === "event" ? "nav-link active" : "nav-link"}
                                                            onClick={() => setTabItem("event")}/>
                                                </li>
                                                <li className={"nav-item"}>
                                                    <Button text={"Reasons"} id={"reason-filter-tab"}
                                                            class={tabItem === "reason" ? "nav-link active" : "nav-link"}
                                                            onClick={() => setTabItem("reason")}/>
                                                </li>
                                                <li className={"nav-item"}>
                                                    <Button text={"Response Time"} id={"response-filter-tab"}
                                                            class={tabItem === "response" ? "nav-link active" : "nav-link"}
                                                            onClick={() => setTabItem("response")}/>
                                                </li>
                                            </ul>
                                            : <></>
                                        }
                                    </div>
                                    <div className={tabItem === "area" ? "d-block" : "d-none"}>
                                        <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                            <input type={"search"} id={"areaSearch"}
                                                   className={"form-control search-input"}
                                                   onKeyUp={(e) => setAreaSearch(e.target.value)}/>
                                            <Button text={""} type={"button"}
                                                    class={"btn btn-primary smooth-radius-left"}
                                                    style={{height: "42px"}} icon={true}
                                                    iconClass={"fe fe-search"}/>
                                        </div>
                                        <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                            <table className={"table table-sm table-white table-hover"}>
                                                <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                {areaTableHeaders}
                                                </thead>
                                                <tbody>
                                                {areaTableRows}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className={tabItem === "areaGroup" ? "d-block" : "d-none"}>
                                        <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                            <input type={"search"} id={"areaGroupSearch"}
                                                   className={"form-control search-input"}
                                                   onKeyUp={(e) => setAreaGroupSearch(e.target.value)}/>
                                            <Button text={""} type={"button"}
                                                    class={"btn btn-primary smooth-radius-left"}
                                                    style={{height: "42px"}} icon={true}
                                                    iconClass={"fe fe-search"}/>
                                        </div>
                                        <table className={"table table-sm table-white table-hover"}
                                               style={{maxHeight: "400px", overflowY: "auto"}}>
                                            <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                            {areaGroupTableHeaders}
                                            </thead>
                                            <tbody>
                                            {areaGroupTableRows}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className={tabItem === "areaType" ? "d-block" : "d-none"}>
                                        <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                            <input type={"search"} id={"areaTypeSearch"}
                                                   className={"form-control search-input"}
                                                   onKeyUp={(e) => setAreaTypeSearch(e.target.value)}/>
                                            <Button text={""} type={"button"} id={"area-type-search-btn"}
                                                    class={"btn btn-primary smooth-radius-left"}
                                                    style={{height: "42px"}} icon={true}
                                                    iconClass={"fe fe-search"}/>
                                        </div>
                                        <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                            <table className={"table table-sm table-white table-hover"}>
                                                <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                {areaTypeTableHeaders}
                                                </thead>
                                                <tbody>
                                                {areaTypeTableRows}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className={tabItem === "resident" ? "d-block" : "d-none"}>
                                        <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                            <input type={"search"} id={"resSearch"}
                                                   className={"form-control search-input"}
                                                   onKeyUp={(e) => setResSearch(e.target.value)}/>
                                            <Button text={""} type={"button"} id={"resident-search-btn"}
                                                    class={"btn btn-primary smooth-radius-left"}
                                                    style={{height: "42px"}} icon={true}
                                                    iconClass={"fe fe-search"}/>
                                        </div>
                                        <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                            <table className={"table table-sm table-white table-hover"}>
                                                <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                {residentTableHeaders}
                                                </thead>
                                                <tbody>
                                                {resTableRows}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className={tabItem === "residentGroup" ? "d-block" : "d-none"}>
                                        <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                            <input type={"search"} id={"residentGroupSearch"}
                                                   className={"form-control search-input"}
                                                   onKeyUp={(e) => setResidentGroupSearch(e.target.value)}/>
                                            <Button text={""} type={"button"} id={"resident-group-search-btn"}
                                                    class={"btn btn-primary smooth-radius-left"}
                                                    style={{height: "42px"}} icon={true}
                                                    iconClass={"fe fe-search"}/>
                                        </div>
                                        <div style={{maxHeight: "400px", overflowY: "auto", display: "block"}}>
                                            <table className={"table table-sm table-white table-hover"}>
                                                <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                {residentGroupTableHeaders}
                                                </thead>
                                                <tbody>
                                                {residentGroupTableRows}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className={tabItem === "user" ? "d-block" : "d-none"}>
                                        <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                            <input type={"search"} id={"userSearch"}
                                                   className={"form-control search-input"}
                                                   onKeyUp={(e) => setUserSearch(e.target.value)}/>
                                            <Button text={""} type={"button"} id={"user-search-btn"}
                                                    class={"btn btn-primary smooth-radius-left"}
                                                    style={{height: "42px"}} icon={true}
                                                    iconClass={"fe fe-search"}/>
                                        </div>
                                        <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                            <table className={"table table-sm table-white table-hover"}>
                                                <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                {userTableHeaders}
                                                </thead>
                                                <tbody>
                                                {userTableRows}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className={tabItem === "userGroup" ? "d-block" : "d-none"}>
                                        <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                            <input type={"search"} id={"userGroupSearch"}
                                                   className={"form-control search-input"}
                                                   onKeyUp={(e) => setUserGroupSearch(e.target.value)}/>
                                            <Button text={""} type={"button"} id={"user-group-search-btn"}
                                                    class={"btn btn-primary smooth-radius-left"}
                                                    style={{height: "42px"}} icon={true}
                                                    iconClass={"fe fe-search"}/>
                                        </div>
                                        <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                            <table className={"table table-sm table-white table-hover"}>
                                                <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                {userGroupTableHeaders}
                                                </thead>
                                                <tbody>
                                                {userGroupTableRows}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className={tabItem === "deviceCat" ? "d-block" : "d-none"}>
                                        <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                            <input type={"search"} id={"devCatSearch"}
                                                   className={"form-control search-input"}
                                                   onKeyUp={(e) => setDevCatSearch(e.target.value)}/>
                                            <Button text={""} type={"button"} id={"device-cat-search-btn"}
                                                    class={"btn btn-primary smooth-radius-left"}
                                                    style={{height: "42px"}} icon={true}
                                                    iconClass={"fe fe-search"}/>
                                        </div>
                                        <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                            <table className={"table table-sm table-white table-hover"}>
                                                <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                {deviceCatTableHeaders}
                                                </thead>
                                                <tbody>
                                                {devCatTableRows}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className={tabItem === "device" ? "d-block" : "d-none"}>
                                        <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                            <input type={"search"} id={"devSearch"}
                                                   className={"form-control search-input"}
                                                   onKeyUp={(e) => setDevSearch(e.target.value)}/>
                                            <Button text={""} type={"button"} id={"device-search-btn"}
                                                    class={"btn btn-primary smooth-radius-left"}
                                                    style={{height: "42px"}} icon={true}
                                                    iconClass={"fe fe-search"}/>
                                        </div>
                                        <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                            <table className={"table table-sm table-white table-hover"}>
                                                <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                {deviceTableHeaders}
                                                </thead>
                                                <tbody>
                                                {devTableRows}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className={tabItem === "event" ? "d-block" : "d-none"}>
                                        <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                            <input type={"search"} id={"typeSearch"}
                                                   className={"form-control search-input"}
                                                   onKeyUp={(e) => setEventTypeSearch(e.target.value)}/>
                                            <Button text={""} type={"button"} id={"event-type-search-btn"}
                                                    class={"btn btn-primary smooth-radius-left"}
                                                    style={{height: "42px"}} icon={true}
                                                    iconClass={"fe fe-search"}/>
                                        </div>
                                        <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                            <table className={"table table-sm table-white table-hover"}>
                                                <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                {eventTypeTableHeaders}
                                                </thead>
                                                <tbody>
                                                {eventTypeTableRows}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className={tabItem === "reason" ? "d-block" : "d-none"}>
                                        <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                            <input type={"search"} id={"reasonSearch"}
                                                   className={"form-control search-input"}
                                                   onKeyUp={(e) => setReasonSearch(e.target.value)}/>
                                            <Button text={""} type={"button"} id={"reason-search-btn"}
                                                    class={"btn btn-primary smooth-radius-left"}
                                                    style={{height: "42px"}} icon={true}
                                                    iconClass={"fe fe-search"}/>
                                        </div>
                                        <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                            <table className={"table table-sm table-white table-hover"}>
                                                <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                {reasonTableHeaders}
                                                </thead>
                                                <tbody>
                                                {reasonTableRows}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className={tabItem === "response" ? "d-block" : "d-none"}>
                                        <div className={"form-check form-switch mt-5 mb-3"}>
                                            <input className={"form-check-input"} id={"response-on"}
                                                   type={"checkbox"}
                                                   onChange={(e) => {
                                                       document.getElementById("response-operator").required = e.target.checked;
                                                       document.getElementById("response-value").required = e.target.checked;
                                                       formCheck("response-form", "");
                                                   }}/>
                                            <label htmlFor={"response-on"}>Filter by response time</label>
                                        </div>
                                        <div className={"form-floating mb-3 d-inline-block me-3 align-top"}
                                             style={{width: "33%"}}>
                                            <select className={"form-select"} id={"response-operator"}>
                                                <option value={"lt"}>Less than</option>
                                                <option value={"gt"}>Greater than</option>
                                                <option value={"eq"}>Equal to</option>
                                            </select>
                                            <label htmlFor={"response-operator"}>Condition</label>
                                        </div>
                                        <div className={"form-floating mb-3 d-inline-block align-top"}
                                             style={{width: "33%"}}>
                                            <input type={"number"} className={"form-control"}
                                                   step={1} min={0} max={3600} id={"response-value"}/>
                                            <label htmlFor={"response-value"}>Response Time (Min)</label>
                                            <div className={"invalid-feedback"}>
                                                Number of minutes required!
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer"}>
                                <div>
                                    <button type={"button"} className={"btn btn-secondary"} id={"cancelFilterBtn2"}
                                            data-bs-dismiss={"modal"} onClick={() => {showModal("editmodal")}}>Cancel
                                    </button>
                                    <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                            spinner={true} text={"Loading"} id={"loadFilterSubmit2"}/>
                                    <button type={"button"} className={"btn btn-primary ms-3"} id={"filterSubmit2"}
                                            onClick={() => filterSubmit2()}>Set
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <BulkDeleteModal
                deletePerform={() => deletePerform("bulkDeleteSubmit", "loadBulkDeleteSubmit", "bulkConfirmClose", ppRules.start, ppRules.end)}
                start={ppRules.start} end={ppRules.end} header={"Disable Reports"}/>
            <PerPageModal filterSubmit={() => filterSubmit()} tmpPerPage={tmpPerPage}
                          setTmpPerPage={(sudocode) => setTmpPerPage(sudocode)}
                          setPage={(sudocode) => setPage(sudocode)}/>
            <button
                type={"button"}
                className={"help-corner-button"}
                onClick={() => showModal("helpmodal")}
                title={"Page Help Popup"}
                aria-label={"Open Help"}
            >
                <i className={"fe fe-help-circle help-corner-button-icon"}></i>
            </button>
            <div className={"modal fade help-modal-pop"} id={"helpmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticHelpBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog modal-lg"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticHelpBackdropLabel"}>Scheduled Reports Page Help</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"} aria-label={"Close"}/>
                        </div>
                        <div className={"modal-body"}>
                            <div className={"mb-4"}>
                                <h4 className={"text-primary mb-3"}>
                                    <i className={"fe fe-info me-2"}></i>Getting Started
                                </h4>
                                <p className={"mb-2"}>
                                    This page allows you to view and manage all scheduled reports for your campus. You can edit scheduled report settings, manually send reports, delete reports, and export the schedule list to CSV.
                                </p>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-list me-2 text-primary"}></i>Scheduled Reports Table
                                </h5>
                                <p className={"mb-2"}>The table displays all scheduled reports with the following information:</p>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}><strong>Report Description</strong>: The name or description of the scheduled report.</li>
                                    <li className={"mb-2"}><strong>Report Type</strong>: The type of report (Event, Group, Environment, Wellness, Maintenance, Executive, etc.).</li>
                                    <li className={"mb-2"}><strong>Frequency</strong>: How often the report is sent (Daily, Weekly, Monthly, etc.).</li>
                                    <li className={"mb-2"}><strong>Send Time</strong>: The time of day when the report is sent.</li>
                                    <li className={"mb-2"}><strong>Report Duration</strong>: The time range covered by the report (Yesterday, Last Week, Last Month, etc.).</li>
                                    <li className={"mb-2"}><strong>Last Sent</strong>: The date and time when the report was last sent.</li>
                                    <li className={"mb-2"}><strong>Next Send Time</strong>: The date and time when the report will be sent next.</li>
                                    <li className={"mb-2"}><strong>Receivers</strong>: The email addresses that receive the scheduled report.</li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-file-text me-2 text-primary"}></i>Table Features
                                </h5>
                                <p className={"mb-2"}>The table includes several interactive features:</p>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}><strong>Column Filters</strong>: Click filter icons in column headers to filter by specific values.</li>
                                    <li className={"mb-2"}><strong>Sorting</strong>: Click column headers to sort data by that column.</li>
                                    <li className={"mb-2"}><strong>Search</strong>: Use the search bar to quickly find reports by description, type, frequency, or other fields.</li>
                                    <li className={"mb-2"}><strong>Pagination</strong>: Use pagination controls at the bottom to navigate through multiple pages of results.</li>
                                    <li className={"mb-2"}><strong>Per Page</strong>: Adjust the number of items displayed per page using the per-page selector.</li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-edit me-2 text-primary"}></i>Editing Scheduled Reports
                                </h5>
                                <p className={"mb-2"}>To edit a scheduled report:</p>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>Click the "Edit" icon (<i className={"fe fe-edit"}></i>) in the actions column for the desired report.</li>
                                    <li className={"mb-2"}>Modify the report description, delivery frequency, send time, or email recipients.</li>
                                    <li className={"mb-2"}>Add or remove email addresses from the recipient list.</li>
                                    <li className={"mb-2"}>Enable or disable PDF summary attachments or CSV detail attachments (where applicable).</li>
                                    <li className={"mb-2"}>Click "Submit" to save your changes.</li>
                                </ul>
                                <p className={"mb-2"}>Note: To change the report contents (filters, date range, etc.), you must delete the current scheduled report and create a new one from the report page.</p>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-send me-2 text-primary"}></i>Manually Sending Reports
                                </h5>
                                <p className={"mb-2"}>You can manually trigger a scheduled report to be sent immediately:</p>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>Click the "Send" icon <i className={"fe fe-send text-dark"}></i> in the actions column for the desired report.</li>
                                    <li className={"mb-2"}>The report will be generated and sent to all configured recipients immediately.</li>
                                    <li className={"mb-2"}>This is useful for testing reports or sending reports outside of the normal schedule.</li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-trash-2 me-2 text-primary"}></i>Deleting Scheduled Reports
                                </h5>
                                <p className={"mb-2"}>To delete one or more scheduled reports:</p>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>Select the checkboxes next to the reports you wish to delete.</li>
                                    <li className={"mb-2"}>Click the <strong>"Disable"</strong> button in the header.</li>
                                    <li className={"mb-2"}>Confirm the deletion in the modal.</li>
                                </ul>
                                <p className={"mb-2"}>Deleting a scheduled report will stop it from being sent automatically, but it will not affect any reports that have already been sent.</p>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-download me-2 text-primary"}></i>Exporting Data
                                </h5>
                                <p className={"mb-2"}>You can export the scheduled reports list to CSV:</p>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>Click the "Export" button to download the current list of scheduled reports as a CSV file.</li>
                                    <li className={"mb-2"}>The CSV includes all visible columns from the table, including report details, schedule information, and recipient lists.</li>
                                </ul>
                            </div>

                            <div className={"mb-3"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-settings me-2 text-primary"}></i>Additional Tips
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>Use the campus dropdown to switch between campuses if you have access to multiple campuses.</li>
                                    <li className={"mb-2"}>The table automatically refreshes every 10 minutes with the latest schedule information.</li>
                                    <li className={"mb-2"}>Scheduled reports are created from individual report pages (Event Reports, Group Reports, etc.) using the "Schedule" button.</li>
                                    <li className={"mb-2"}>Email addresses must be valid and properly formatted to receive reports.</li>
                                    <li className={"mb-2"}>PDF summaries provide a condensed overview, while CSV details include all report data.</li>
                                    <li className={"mb-2"}>Use the search function to quickly find specific scheduled reports by name or type.</li>
                                    <li className={"mb-2"}>The "Next Send Time" column shows when each report will be automatically sent next.</li>
                                </ul>
                            </div>
                        </div>
                        <div className={"modal-footer"}>
                            <button type={"button"} className={"btn btn-secondary"} data-bs-dismiss={"modal"}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
            <input type={"hidden"} id={"dContent"}/>
            <input type={"hidden"} id={"uContent"}/>
            <Suspense fallback={"Loading..."}>
                <ToastContainer position={"bottom-right"} theme={"colored"} newestOnTop={true} pauseOnHover={true}
                                autoClose={10000} closeOnClick={true}/>
            </Suspense>
        </>
    );
};

export default ScheduledReports;